import { useNavigate } from "react-router-dom";
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    Typography,
} from "@mui/material";
import SearchBar from "../../../components/SearchBar";
import { useEffect, useState } from "react";
import SwitchToggle from "../../../components/SwitchToggle";
import { useLazyGetEngineQuery } from "../../../services/multilingualEngine";
import Panigation from "../../../components/Panigation";
import IfCan from "../../../components/IfCan";

const MultilingualEngine = () => {
    const navigate = useNavigate();
 
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [getEngine] = useLazyGetEngineQuery();

  const getUserList = async () => {
    setIsLoading(true);
    try {
      const response = await getEngine({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUserList();
  }, [page, debouncedSearchTerm]);

  const columns = [
    { id: 'language', label: 'Language' },
    { id: 'accuracyLogs', label: 'Accuracy Logs' },
    { id: 'status', label: 'Enable/Disable' },
  ];

    return (
        <>
            <div className="main_title">
                <h1>Multilingual Engine</h1>
                <p>
                    <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Multilingual Engine
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                value={searchTerm}
                                onChange={(e: any) => setSearchTerm(e.target.value)}
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setDebouncedSearchTerm}
                                placeholder="Search languages..."
                            />
                        </Box>
                    </div>

                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow hover>
                                {columns.map((column) => (
                                    <TableCell key={column.id}>{column.label}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        <Typography>Loading...</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : data.length > 0 ? (
                                data.map((row, index) => (
                                    <TableRow hover key={row.id || index}>
                                        <TableCell>{row.language || 'N/A'}</TableCell>
                                        <TableCell>
                                            <div>
                                                <div>OCR Accuracy: <strong>{row.ocr_accuracy || 0}%</strong></div>
                                                <div>Voice Score: <strong>{row.voice_score || 0}%</strong></div>
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <IfCan module="AI Behavior Language" action="add_edit">
                                                <SwitchToggle />
                                            </IfCan>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        <Typography>No data available</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                {data.length > 0 && (
                    <Panigation
                        module={data}
                        totalCount={totalCount}
                        page={page}
                        setPage={setPage}
                        totalPages={Math.ceil(totalCount / 10)}
                        onPageChange={(newPage) => setPage(newPage)}
                    />
                )}
            </div>
        </>
    );
};

export default MultilingualEngine;
